export { AdditionalDescription, type Props } from './index.pc'
export { MobileAdditionalDescription } from './index.mobile'
